import WaitingForControlIcon from './component'

export default WaitingForControlIcon
